import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/user/info',
  title: '修改个人信息',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
